import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import WoodOrder from "./types/wood/WoodOrder";
import WindowOrder from "./types/WindowOrder";
import SkylightOrder from "./types/SkylightOrder";
import CablesOrder from "./types/CablesOrder";
import RoofingOrder from "./types/RoofingOrder.js";
import { useFirestore } from "react-redux-firebase";
import { useProjects } from "../../../hooks/useContacts";

function OrderControl({ yurtTrait, walls, id }) {
  const firestore = useFirestore();

  let { docs: projects } = useProjects();
  const project = projects.filter((e) => e.id === id)[0];

  const handleProjectEdit = (name, value) => {
    firestore
      .collection("projects")
      .doc(project.id)
      .update({ [name]: value });
  };

  return (
    <>
      {typeof project !== "undefined" ? (
        <div className="order-control">
          <Tabs>
            <TabList>
              <Tab>Wood</Tab>
              <Tab>Windows</Tab>
              <Tab>Skylights</Tab>
              <Tab>Cables</Tab>
              <Tab>Roofing</Tab>
            </TabList>
            <TabPanel>
              <WoodOrder
                handleProjectEdit={handleProjectEdit}
                project={project}
              />
            </TabPanel>
            <TabPanel>
              <WindowOrder yurtTrait={yurtTrait} walls={walls} />
            </TabPanel>
            <TabPanel>
              <SkylightOrder yurtTrait={yurtTrait} walls={walls} />
            </TabPanel>
            <TabPanel>
              <CablesOrder yurtTrait={yurtTrait} walls={walls} />
            </TabPanel>
            <TabPanel>
              <RoofingOrder yurtTrait={yurtTrait} walls={walls} />
            </TabPanel>
          </Tabs>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}

export default OrderControl;
